import { formatCPF, formatCNPJ, formatPhone } from "react-data-formatter";

export const formatPixKey = key => ({
  EMAIL: `e-mail - ${key}`,
  CPF: `CPF - ${formatCPF(key)}`,
  PHONE: `celular - ${formatPhone(key)}`,
  CNPJ: `CNPJ - ${formatCNPJ(key)}`,
  EVP: `chave aleatória - ${key}`,
});
